export default __webpack_public_path__ + "static/Digital-transformation-977a14ee7aed1b27c7130d7120b75cc7.webp";